import { Route } from "@angular/router";
import { DavComponent } from "./dav.component";

export const DavRouting: Route = {
  path: 'dav',
  component: DavComponent,
  data: {
    breadcrumb: "DAV"
  },
};
